import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import SideNav from "./SideNav";
// import Auth from "./Auth";
import Notes from "./Notes";
import Contact from "./Contact";
import Common from "./Common";
import BaseConfig from "./BaseConfig";
import Dashboard from "./Dashboard";
import News from "./News";
import Download from "./Download";
import Instance from "./Instance";
import Reminder from "./Reminder";
import Letter from "./Letter";
import Attachment from "./Attachment";
import LetterBody from "./LetterBody";
import ConvertStatus from "./ConvertStatus";
import LetterBodyImage from "./LetterBodyImage";
import Secretariat from "./Secratariat";
import LetterReferTypesStatics from "./LetterReferTypesStatics";
import EmployeePositionFolders from "./EmployeePositionFolders";
import EmployeePosition from "./EmployeePosition";
import Assign from "./Assign";
import NewLetter from "./NewLetter";
import DraftEditor from "./DraftEditor";
import GetGuid from "./GetGuid";
import UploadFile from "./UploadFile";
import DeleteDraft from "./DeleteDraft";
import Signature from "./Signature";
import Archive from "./Archive";
import FastSign from "./FastSign";
import Memo from "./Memo";
import Folder from "./Folder";
import LetterRelation from "./LetterRelation";
import FgChat from "./ChatV2";
import Appointment from "./Appointment";
import Bpm from "./Bpm";
import UserConfig from "./UserConfig";
import SendLetter from "./SendLetter";

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    sideNav: SideNav,
    notes: Notes,
    contact: Contact,
    common: Common,
    baseConfig: BaseConfig,
    dashboard: Dashboard,
    news: News,
    download: Download,
    instance: Instance,
    reminder: Reminder,
    letter: Letter,
    attachment: Attachment,
    letterBody: LetterBody,
    convertStatus: ConvertStatus,
    letterBodyImage: LetterBodyImage,
    secretariat: Secretariat,
    letterReferTypesStatics: LetterReferTypesStatics,
    employeePositionFolders: EmployeePositionFolders,
    employeePosition: EmployeePosition,
    assign: Assign,
    newLetter: NewLetter,
    draftEditor: DraftEditor,
    getGuid: GetGuid,
    uploadFile: UploadFile,
    deleteDraft: DeleteDraft,
    signature: Signature,
    archive: Archive,
    fastSign: FastSign,
    memo: Memo,
    folder: Folder,
    letterRelation: LetterRelation,
    fgChat: FgChat,
    appointment: Appointment,
    bpm: Bpm,
    userConfig: UserConfig,
    sendLetter: SendLetter
  });

export default createRootReducer;
